module.exports = __webpack_public_path__ + "static/media/aq.af77d009.png";